import { render, staticRenderFns } from "./ModelLinkSummaryModal.vue?vue&type=template&id=33a2f94a"
import script from "./ModelLinkSummaryModal.vue?vue&type=script&lang=ts"
export * from "./ModelLinkSummaryModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports